import { Header } from './Header';
import { Footer } from './Footer';
import { StickyWhatsApp } from '../common/StickyWhatsApp';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-alabaster">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <StickyWhatsApp />
    </div>
  );
};
